import { render } from "./SendEmailButton.vue?vue&type=template&id=3bb9038a"
import script from "./SendEmailButton.vue?vue&type=script&lang=js"
export * from "./SendEmailButton.vue?vue&type=script&lang=js"

import "./SendEmailButton.vue?vue&type=style&index=0&id=3bb9038a&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__